import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import FormField from "ds/components/Form/Field";
import DescriptionDetails from "components/DescriptionDetails";
import { Stack } from "types/generated";
import FormFieldViewText from "components/FormFields/ViewText";
import {
  getStackDetailsNameTooltip,
  getStackDetailsSpaceTooltip,
} from "views/Stack/Settings/components/getTooltips";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import WorkerPoolMetaInfoItem from "shared/WorkerPool/MetaInfoItem";
import { AccessResult } from "utils/access";
import { getWorkerPoolTooltip } from "views/Stack/Settings/Behavior/getTooltips";

type StackDetailsProps = {
  editUrl?: string;
  onOpenFullDescription: () => void;
  stack: Stack;
  hasStackAdminAccess: AccessResult;
  withWorkerPool?: boolean;
};

const StackDetails = ({
  editUrl,
  onOpenFullDescription,
  stack,
  hasStackAdminAccess,
  withWorkerPool,
}: StackDetailsProps) => {
  return (
    <>
      <FormFieldViewText
        label="Name"
        value={stack.name}
        noMargin
        {...getStackDetailsNameTooltip()}
      />

      <FormField label="Space" noMargin {...getStackDetailsSpaceTooltip()}>
        <SpacePath
          variant="expandable"
          spaceId={stack.spaceDetails.id}
          fallbackName={stack.spaceDetails.name}
        />
      </FormField>

      {withWorkerPool && (
        <FormField label="Worker pool" noMargin {...getWorkerPoolTooltip()}>
          <WorkerPoolMetaInfoItem workerPool={stack.workerPool} />
        </FormField>
      )}

      <DescriptionDetails
        description={stack.description}
        onOpenFullDescription={onOpenFullDescription}
        {...(hasStackAdminAccess.result && { addDescriptionUrl: editUrl })}
        noMargin
      />

      <FormField label="Labels" noMargin>
        <TagsList
          tags={stack.labels}
          {...(hasStackAdminAccess.result && { addTagsUrl: editUrl })}
          alwaysExpanded
          withEmptyPlaceholder
        />
      </FormField>

      {stack.stateSetAt && (
        <FormFieldTimestamp
          timestamp={stack.stateSetAt}
          label="The last change to the stack state"
          noMargin
        />
      )}
    </>
  );
};

export default StackDetails;
